import { RootState } from "@/app/appStore";

export const selectSidebar = (state: RootState) => state.layoutSidebar;
export const selectIsSidebarOpen = (state: RootState) => state.layoutSidebar.isSidebarOpen;